module.exports = __webpack_public_path__ + "f94735f07c917ac93183d2f42f0843e3.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_small_x1/public/history/fi-1999_0.png
// module id = 421
// module chunks = 0